import BigNumber from 'bignumber.js'

export const BIG_TWO = new BigNumber(2)
export const BIG_TEN = new BigNumber(10)
export const BIG_ZERO = new BigNumber(0)
export const DEFAULT_TOKEN_DECIMAL = new BigNumber(10).pow(18)
export const getNumberFromBigInt = (value: unknown, decimals = 18) => {
  const bigNumberBalance =
    typeof value === 'bigint' ? new BigNumber(value.toString()) : BIG_ZERO
  const displayBalance = new BigNumber(bigNumberBalance).dividedBy(BIG_TEN.pow(decimals))
  return displayBalance.toNumber()
}
export const getFullDisplayBalance = (balance: BigNumber, decimals = 8) => {
  const newNumber = new BigNumber(balance)
  const realNumber = newNumber.dividedBy(BIG_TEN.pow(18)).toFixed(decimals)
  return realNumber.toString()
}
